import { Component } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { AuthenticatorComponent } from './tools/authenticator/authenticator.component';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { Router, NavigationEnd } from '@angular/router';
import { FirebaseTSFirestore } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { AuthService } from './services/auth.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'Lenali';
  auth = new FirebaseTSAuth();
  firestore = new FirebaseTSFirestore();
  userHasProfile = true;
  showFooter = true;
  currentYear = new Date().getFullYear();
  private static userDocument: UserDocument;

  constructor(private loginSheet: MatBottomSheet,
      private router: Router
    ){
      
    // Écouter les changements de routes pour masquer le footer sur certaines pages
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // Masquer le footer sur la page postfeed (qui contient déjà une navigation)
      this.showFooter = !event.url.includes('postfeed');
    });
    
    this.auth.listenToSignInStateChanges(
      user => {
        this.auth.checkSignInState(
          {
            whenSignedIn: user => {
              
              // Si l'utilisateur est connecté avec un numéro de téléphone
              const currentUser = this.auth.getAuth().currentUser;
             

              /* if (currentUser?.phoneNumber) {
                console.log("Utilisateur connecté avec un numéro de téléphone vérifié:", currentUser.phoneNumber);
                this.getUserProfile(); // Récupérer le profil utilisateur
              } */
              if (currentUser) {
                if (currentUser.isAnonymous) {
                 /* console.log("Utilisateur connecté en tant qu'anonyme");
                  this.router.navigate(["profileSetup"]); // Rediriger vers la configuration du profil */
                } else if (currentUser.phoneNumber) {
                  console.log("Utilisateur connecté avec un numéro de téléphone:", currentUser.phoneNumber);
                  this.getUserProfile();
                } else if (currentUser.emailVerified) {
                  this.getUserProfile();
                } else if (currentUser.email.endsWith("@lenali.ml")) {
                  
                }
              }
              
            },
            whenSignedOut: user => {
              AppComponent.userDocument = null;
              
            },
            whenSignedInAndEmailNotVerified: user => {
              const currentUser = this.auth.getAuth().currentUser;
              if (currentUser) {
                if (currentUser.email.endsWith("@lenali.ml")) {
                  //alert("izi");
                  this.getUserProfile();
                } else
                if (!currentUser.isAnonymous && !currentUser.emailVerified && !currentUser.email.endsWith("@lenali.ml")) {
                  this.router.navigate(["emailVerification"]);
                } else if (currentUser.phoneNumber) {
                  console.log("Utilisateur connecté avec un numéro de téléphone:", currentUser.phoneNumber);
                  this.getUserProfile();
                } else if (currentUser.emailVerified) {
                  this.getUserProfile();
                } 
              }
             
            },
            whenSignedInAndEmailVerified: user => {
              this.getUserProfile();
              
            },
            whenChanged: user => {

            },
          }
        );
      }
    );
  }
  public static getUserDocument(){
    return AppComponent.userDocument;
  }
  getUsername(){
    try {
      return AppComponent.userDocument.publicName;
    } catch (err) {
      
    }
  }
  getUserProfile(){
    
    return new Promise<number>(
      (resolved, rejected) => {
        this.firestore.listenToDocument(
          {
            name: "Getting Document",
            path: ["Users", this.auth.getAuth().currentUser.uid],
            onUpdate: (result) => {
              AppComponent.userDocument = <UserDocument>result.data();
              
              if(result){
                
                this.userHasProfile = result.exists; 
                
              
              }else{
                this.userHasProfile = false;
               
              }
              AppComponent.userDocument.userId = this.auth.getAuth().currentUser.uid;
              if(this.userHasProfile && this.loggedIn()) {
                this.router.navigate(["postfeed"]);
                resolved(1);
              } else {                
                resolved(0);
              }              
            }
          }
        );
      }
    );
    
  }

  onContinueClick(
    nameInput: HTMLInputElement,
    villeInput: HTMLInputElement,
    descriptionInput: HTMLTextAreaElement
  ) {
    let name = nameInput.value;
    let ville = villeInput.value;
    let description = descriptionInput.value;
    let uid = this.auth.getAuth().currentUser.uid;
    this.firestore.create(
      {
        path: ["Users", this.auth.getAuth().currentUser.uid],
        data: {
          publicName: name,
          ville: ville,
          description: description,
          profilePhotoUrl: "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/0d64989794b1a4c9d89bff571d3d5842.jpg?alt=media&token=00eab294-e45f-4eb8-abf0-ecf19763b03c",
          coverPhotoUrl: "https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/defaultCoverImage.jpg?alt=media&token=d509e05d-dd94-4ff3-b37f-24430c3a82bf",
          followers: [],
          following: [],
          uid: uid,
        },
        onComplete: (docId) => {
          alert("Votre profil a bien été Crée!");
          nameInput.value = "";
          descriptionInput.value = "";
        },
        onFail: (err) => {

        }
      }
    );
  }



  add(number1, number2) {
    return number1 + number2;
  }
  onLogoutClick(){
    this.auth.signOut();
  }

  loggedIn(){
    return this.auth.isSignedIn();
  }

  onLoginClick(){
    this.loginSheet.open(AuthenticatorComponent);
  }
}

export interface UserDocument {
  publicName: string;
  description: string;
  userId: string;
  profilePhotoUrl: string;
  coverPhotoUrl: string;
  ville: String;
}
